import { type MutationTree } from 'vuex';

import { type IPrivateContactLeadState } from './types';

export const RECEIVE_BY_LEAD = 'receiveByLead';

export const mutations: MutationTree<IPrivateContactLeadState> = {
    [RECEIVE_BY_LEAD](_state: IPrivateContactLeadState, { leadId, idList }: { leadId: number; idList: number[] }) {
        _state.byLead.set(leadId, idList);
    }
};
